import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import "./errorable.css";

class Errorable extends PureComponent {
  getClassName = () => {
    return (
      `errorable__background ` +
      `errorable__background--${this.props.error ? "visible" : "invisible"} ` +
      `errorable__background--${this.props.dark ? "dark" : "light"}`
    );
  };

  render() {
    return (
      <div className="errorable">
        {this.props.children}
        <div className={this.getClassName()}>
          <div className="errorable__content">{this.props.errorMessage}</div>
        </div>
      </div>
    );
  }
}

Errorable.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  dark: PropTypes.bool
};

Errorable.defaultProps = {
  error: false,
  errorMessage: null,
  dark: false
};

export default Errorable;



// WEBPACK FOOTER //
// ./src/components/support/errorable/index.jsx